import { useMemo } from 'react'

export const useAdminPagesSlice = <
  TPages,
  TSetPages,
  TOpenCreatePage,
  TOpenEditPage,
  THandlePageSaved,
  THandlePageCancel,
  TPageEditorMode,
  TPageEditorId,
>({
  pages,
  setPages,
  openCreatePage,
  openEditPage,
  handlePageSaved,
  handlePageCancel,
  pageEditorMode,
  pageEditorId,
}: {
  pages: TPages
  setPages: TSetPages
  openCreatePage: TOpenCreatePage
  openEditPage: TOpenEditPage
  handlePageSaved: THandlePageSaved
  handlePageCancel: THandlePageCancel
  pageEditorMode: TPageEditorMode
  pageEditorId: TPageEditorId
}) =>
  useMemo(
    () => ({
      pages,
      setPages,
      openCreatePage,
      openEditPage,
      handlePageSaved,
      handlePageCancel,
      pageEditorMode,
      pageEditorId,
    }),
    [
      handlePageCancel,
      handlePageSaved,
      openCreatePage,
      openEditPage,
      pageEditorId,
      pageEditorMode,
      pages,
      setPages,
    ],
  )
